// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"e65263f7","151":"7cb10ae2","195":"ddbf7450","279":"3fe86476","285":"478db4c9","365":"f545f012","432":"ebe6049a","487":"2125c271","633":"aa571bfe","741":"9adbbdf0","787":"4e01de2c","805":"9655d58d","983":"8742c1d5"}[chunkId] + ".chunk.js";
};